import React from 'react';

import config from '../../config';
import { translate as t } from '../../lib/I18n';

import Banner from './Banner';


function BetaBanner () {
    return (
        <Banner className="banner--beta" bodyClassName="body--banner-beta">
            <div className="pull-left">
                <span className="banner--beta__beta">
                    { t('global.banner.beta.logo.text') }
                </span>

                { ' ' + t('global.banner.beta.text') + ' ' }

                <a className="text-weight--bold" href={ config.get('helpUrl') } target="_blank">
                    { t('global.banner.beta.help') }
                </a>
            </div>
        </Banner>
    );
}


export default BetaBanner;



// WEBPACK FOOTER //
// ./src/components/general/BetaBanner.js